module.exports = __webpack_public_path__ + "img/icons BFr_4.ffce5af3.png";